import { createContext, useContext, useState } from 'react';
export const WizardContext = createContext();
export const useWizard = () => useContext(WizardContext);

export function WizardProvider({ children }) {
  const [draft, setDraft] = useState({});
  return (
    <WizardContext.Provider value={{ draft, setDraft }}>
      {children}
    </WizardContext.Provider>
  );
}
